<template>
  <div>
    <div
      class="activity-header"
      :style="{
        paddingTop: stateHeight,
      }"
    >
      <van-nav-bar :border="false" :title="title" class="navbar" placeholder>
        <template #left>
          <div class="left">
            <img
              class="icon-back"
              src="../ActivityHeader/images/icon-back.png"
              @click="handleBack"
            />
          </div>
        </template>
        <template #title> </template>
        <template #right> </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <img src="./images/empty.png" alt="" />
      <div>活动已结束</div>
      <div class="backBtn" @click="handleBack">{{ time }}s 后返回</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityEmpty",
  props: {
    prevLink: {
      type: String,
      default: "",
    },
    countDown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stateHeight: 0,
      time: 3,
      title: '',
    };
  },
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    if (!this.countDown) return;
    setInterval(() => {
      if (this.time > 0) {
        this.time--;
      }
      if (this.time <= 0) {
        this.$base.goHome(this.prevLink);
      }
    }, 1000);
  },
  methods: {
    handleBack() {
      this.$base.goHome(this.prevLink);
    },
  },
};
</script>

<style lang="less" scoped>
.activity-header {
  min-height: 44px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.icon-back {
  display: inline-block;
  width: 24px;
  height: 24px;
}
/deep/.van-nav-bar {
  height: 44px;
  width: 100%;
  .van-nav-bar__content {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px 0 17px;
    position: relative;
    .van-nav-bar__title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 16px;
    }
  }
}
.content {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%) translateY(-40%);
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #222222;
  line-height: 20px;
  font-style: normal;
  img {
    width: 113px;
    height: 89px;
    margin-bottom: 10px;
  }
  .backBtn {
    width: 91px;
    height: 28px;
    background: #ff6c0e;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    margin: auto;
    margin-top: 14px;
  }
}
</style>
